<div class="container-fluid">
  <div class="form-step three-stup">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div> -->
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pagar</span>
      </div>
      <!-- <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Certificado</span>
      </div> -->
    </div>
  </div>
  
  <span class="letter-style-normal font-weight-bolder text-center d-block pt-3">En solo tres pasos podrás cotizar tu seguro. ¡Empecemos!</span>


<!-- Stup 1 -->
  <div class="form-section">
    <div class="form-left-section form-itams">
      <img [attr.alt]="ballPink1srcNew" [attr.src]="ballPink1srcNew" class="img-fluid style-img-basketball" />
    </div>
    <form [formGroup]="stepTwoForm" class="form-general-style">
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 margin-mt-10">
          
            <app-input-field 
            [formGroup]="stepTwoForm" 
            controlName="agentCode" id="code" label="Código Consultor (Opcional)"
            (inputBlur)="validateAgentCode()"
            [errorMessage]="agentCodeError"
            [submitted]="true"
            ></app-input-field>
            <div class="text-danger">
              <label *ngIf="agentCodeLoading"
              class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
              Validating...</label>
              <label *ngIf="agentCodeError" 
                class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                {{ agentCodeError }}
              </label>
            </div>

          <!-- <div class="form-group">
            <input type="text" class="form-input input-form-full-space user-input-style" formControlName="agentCode"
              id="code" onkeyup="this.setAttribute('value', this.value);" value="">
            <label for="code" class="form-input-label">Código<span> (Opcional si lo tiene)</span></label>
          </div> -->
        </div>
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 margin-mt-10">
          
            <app-dropdown 
              searchPlaceholder="Buscar país…"
              [formGroup]="stepTwoForm" 
              [options]="countries" 
              formControlName="selectedResidentCountry"
              controlName="selectedResidentCountry"
              optionSelected="stepTwoForm.controls['selectedResidentCountry'].value"
              icon="/assets/external/localization-vector.svg"
              label="País de Origen"
              errorMessage="País de Origen"
              [submitted]="submitted"
              >
            </app-dropdown>
            <!-- <p-dropdown [options]="countries" optionLabel="name" optionValue="phoneCode" [filter]="true"
              [filterBy]="'text'" id="phoneCodeId" class="p-dropdown form-input"  onclick="this.setAttribute('value', this.value);" value="">
              <ng-template pTemplate="selectedItem" let-item>
                <div class="d-flex align-items-center">
                  <span>{{ item.text }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-item>
                <div class="d-flex align-items-center">
                  <span>{{ item.text }}</span>
                </div>
              </ng-template>
            </p-dropdown> -->
            <!-- <select name="miselect" formControlName="selectedResidentCountry" id="selectedResidentCountry" onclick="this.setAttribute('value', this.value);" value=""
              class="p-dropdown p-dropdown-icon form-input">
              <option [value]="item.id" *ngFor="let item of countries">{{item.text}}</option>
            </select>             -->
            <!-- <label for="selectedResidentCountry" class="form-input-label">País de residencia *</label> -->
            
          
        </div>
      </div>
      <div class="row formControlRow mb-16px">
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 margin-mt-10">
          <!-- <div class="form-group"> -->
            
            <app-dropdown 
              searchPlaceholder="Buscar país…"
            [formGroup]="stepTwoForm" 
            [options]="regionToFly"
            formControlName="selectedTravelCountry"
            controlName="selectedTravelCountry"
            optionSelected="stepTwoForm.controls['selectedTravelCountry'].value"
            label="Destino Final"
            icon="/assets/external/localization-vector.svg"
            errorMessage="Destino Final"
            [submitted]="submitted"
            >
          </app-dropdown>
            <!-- <select name="miselect" formControlName="selectedTravelCountry" id="selectedTravelCountry"
              onclick="this.setAttribute('value', this.value);" value="" class="p-dropdown p-dropdown-icon form-input">
              <option [value]="item.id" *ngFor="let item of regionToFly">{{item.text}}</option>
            </select> -->
            <!-- <label for="selectedTravelCountry" class="form-input-label">¿Cual es el destino final? *</label> -->
            <!-- <div class="text-danger"
              *ngIf="submitted && stepTwoForm.controls['selectedTravelCountry'].errors?.required">
              <label class="label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Destino final
              </label>
            </div> -->
          <!-- </div> -->
        </div>
        <div class="formControlContainer col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex align-items-center margin-mt-10">
          <div class="form-group w-100">
            <p-calendar id="rangeDates" formControlName="rangeDates" class="d-flex w-100 form-input"
              [class.isEmpty]="stepTwoForm.get('rangeDates')?.value === '' || stepTwoForm.get('rangeDates')?.value === null"
              selectionMode="range" [iconDisplay]="'input'" [showIcon]="true" inputId="templatedisplay"
              [minDate]="minDate" onclick="this.setAttribute('value', this.value);" value="">
              <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
                <i class="pi pi-calendar pointer-events-none" (click)="clickCallBack($event)"></i>
              </ng-template>
            </p-calendar>
            <label for="rangeDates" class="form-input-label">Fechas del viaje</label>
            <div class="text-danger" *ngIf="submitted && stepTwoForm.controls['rangeDates'].errors?.required">
              <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                Rango de fecha
              </label>
            </div>
            <div class="text-danger" *ngIf="dateRangeErrorMessage || stepTwoForm.controls['rangeDates'].errors?.minDuration">
              <label class="feld-error label-form-style d-flex pl-2" style="color: #E40052; font-weight: 500;">
                <img [attr.src]="'/assets/external/warnning-vector.svg'" class="img-fluid pr-1" />
                {{ dateRangeErrorMessage || 'Mínimo 3 días de viaje' }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group" *ngIf="duration > 0">
        <label class="label-form-style d-flex pl-2" style="color: #2828E0; font-weight: 500;">
          <img [attr.src]="'/assets/external/check-vector.svg'" class="img-fluid pr-1" />
          {{duration}} {{duration == 1 ? ('día de Viaje') : ('días de Viajes')}}
        </label>
      </div>
      <div class="form-group mb-0">
        <button type="submit" (click)="nextStep()" class="btn btn-primary continue-btn-steps py-3"
        [disabled]="agentCodeLoading || agentCodeError"
        >Continuar</button>
      </div>
    </form>
    <div class="form-right-section form-itams">
      <img [attr.alt]="towerNew" [attr.src]="towerNew" class="img-fluid style-img-tower" />
    </div>
    
    <a href="javascript:void(0)" class="back-link">< Atrás</a>
    <div class="copy-right">
      <p>All rights reserved by BAC Financial Services. | Política de privacidad | Design by <a href="https://www.wemarkforyou.com">www.wemarkforyou.com</a> </p>
      <h5>Politica de privacidad</h5>
    </div>

  </div>
  
</div>
